const infoMap = [
    {
        title: 'Info',
        perRow: 2,
        arr: [
            {
                key: 'offerName',
                type: 'text',
                val: '',
                label: 'Name',
                required: true,
                fullWidth: false
            },
            {
                key: 'advertiserId',
                type: 'autoCompleteApi',
                val: 'allAdvertiser',
                label: 'Advertiser Name',
                returnKey: 'name',
                displayKey: 'name',
                required: true,
                fullWidth: false
            },
            {
                key: 'websiteBaseUrl',
                type: 'autoCompleteApi',
                val: 'allWebsite',
                label: 'Website',
                returnKey: 'baseUrl',
                displayKey: 'baseUrl',
                required: false,
                fullWidth: true
            },
            {
                key: 'isHosted',
                type: 'switch',
                val: 'isHosted',
                label: 'Hosted',
                disabled: false,
                fullWidth: false
            },
            {
                key: 'multiOffer',
                type: 'switch',
                val: 'multiOffer',
                label: 'Multi Offer',
                disabled: true,
                fullWidth: false
            },
            {
                key: 'agencyFee',
                type: 'percentage',
                val: 'agencyFee',
                label: 'Agency Fee',
                disabled: false,
                fullWidth: false
            }
        ]
    }, {
        title: 'Notes',
        perRow: 1,
        arr: [
            {
                key: 'notes',
                type: 'textArea',
                val: 'offerNote',
                label: 'Offer Notes',
                required: false,
                fullWidth: false
            },
        ]
    },
    {
        title: 'EVERFLOW',
        perRow: 2,
        arr: [
            {
                key: 'everflowOfferId',
                label: 'Everflow Offer Id',
                type: 'text',
                inputType: 'number',
                val: "",
                required: true
            },
            {
                key: 'everflowOfferHash',
                label: 'Everflow Offer Hash',
                type: 'text',
                inputType: 'string',
                val: "",
                required: true
            },
        ]
    }
];

const urlFields = [{
    title: 'Url Info',
    perRow: 2,
    arr: [
        {
            key: 'name',
            type: 'text',
            val: '',
            label: 'Name',
            required: true,
            fullWidth: false
        },
        {
            key: 'url',
            type: 'text',
            val: '',
            label: 'Base Url',
            required: true,
            fullWidth: false,
        },
        {
            key: 'active',
            type: 'switch',
            val: true,
            label: 'Active',
            required: false,
            fullWidth: false
        },
        {
            key: 'default',
            type: 'switch',
            val: false,
            label: 'Default',
            required: false,
            fullWidth: false
        },
        {
            key: 'forwardQueryParams',
            type: 'switch',
            val: false,
            label: 'Forward Query Params',
            required: false,
            fullWidth: false
        },
    ]
}];

const subOfferFields = [{
    title: 'Sub Offer',
    perRow: 5,
    arr: [
        {
            key: 'offerId',
            type: 'text',
            val: '',
            label: 'Offer Id',
            required: true,
            fullWidth: false
        }
    ]
}];

const paramFields = [
    {
        key: 'parameterName',
        type: 'text',
        val: '',
        label: 'Parameter Name',
        required: false,
        fullWidth: false
    },
    {
        key: 'sourceData',
        type: 'autoComplete',
        val: 'allSourceData',
        label: 'Source Data',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false,
        sort: true,
    },
    {
        key: 'constantValue',
        type: 'text',
        val: '',
        label: 'Constant Value',
        required: false,
        fullWidth: false,
    },
    {
        key: 'deleteFlag',
        delete: false,
        required: false,
    }
];


export {infoMap, urlFields, paramFields, subOfferFields};